/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplyHazmatOverrideRequest } from '../models/ApplyHazmatOverrideRequest';
import type { GetHazmatResponse } from '../models/GetHazmatResponse';
import type { RemoveHazmatOverrideRequest } from '../models/RemoveHazmatOverrideRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HazmatService {
  /**
   * Get a carrier certificate's Hazmat determination, override, and (for staff) T31 codes and override history.
   * @param carrierId
   * @returns GetHazmatResponse OK
   * @throws ApiError
   */
  public static getCarrierHazmat(
    carrierId: string,
  ): CancelablePromise<GetHazmatResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Hazmat/carriers/{carrierId}',
      path: {
        'carrierId': carrierId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Designate a carrier's certificate Hazmat or Non-Hazmat. Replaces any override already applied.
   * @param carrierId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static applyCarrierHazmatOverride(
    carrierId: string,
    requestBody?: ApplyHazmatOverrideRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Hazmat/carriers/{carrierId}/override',
      path: {
        'carrierId': carrierId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Remove a carrier certificate's Hazmat override. The system determination applies again.
   * @param carrierId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static removeCarrierHazmatOverride(
    carrierId: string,
    requestBody?: RemoveHazmatOverrideRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Hazmat/carriers/{carrierId}/override',
      path: {
        'carrierId': carrierId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Get an application's Hazmat determination, override, and (for staff) T31 codes and override history.
   * @param applicationId
   * @returns GetHazmatResponse OK
   * @throws ApiError
   */
  public static getApplicationHazmat(
    applicationId: string,
  ): CancelablePromise<GetHazmatResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Hazmat/applications/{applicationId}',
      path: {
        'applicationId': applicationId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * Designate an application Hazmat or Non-Hazmat.
   * @param applicationId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static applyApplicationHazmatOverride(
    applicationId: string,
    requestBody?: ApplyHazmatOverrideRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Hazmat/applications/{applicationId}/override',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
  /**
   * Remove an application's Hazmat override. The system determination applies again.
   * @param applicationId
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static removeApplicationHazmatOverride(
    applicationId: string,
    requestBody?: RemoveHazmatOverrideRequest,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/Hazmat/applications/{applicationId}/override',
      path: {
        'applicationId': applicationId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        409: `Conflict`,
      },
    });
  }
}
